import React from 'react';
import type { LazyRouteFunction, RouteObject } from 'react-router';

export function lazyRoute(
  importFn: () => Promise<{ default: React.ComponentType<Record<string, never>> }>,
): LazyRouteFunction<RouteObject>;

export function lazyRoute<Props extends object>(
  importFn: () => Promise<{ default: React.ComponentType<Props> }>,
  props: Props,
): LazyRouteFunction<RouteObject>;

export function lazyRoute<Props extends object>(
  importFn: () => Promise<{ default: React.ComponentType<Props> }>,
  props?: Props,
): LazyRouteFunction<RouteObject> {
  return async () => {
    const { default: Component } = await importFn();
    return { element: <Component {...(props ?? ({} as Props))} /> };
  };
}
